<template>
	<div id='container' class="root" ref="root" @scroll="scrollEvent">
		<mNavHeader v-if='showHeaderAndFooter&&!hideHeader' :menus='topMenus' :active='active' class='mheader' :customer='customer' @colseCustomer='colseCustomer'  @search='search' />
		<NavHeader v-if='showHeaderAndFooter&&!hideFooter' :menus='topMenus' :active='active' class='header'></NavHeader>
		<div class="container" :style='showHeaderAndFooter && !hideHeader?null:{paddingTop:"10px"}'>
			<slot v-if='!loading'></slot>
			<loading class='loading' v-else/>

			
		</div>
		<Service v-if='showHeaderAndFooter && !hideFooter' v-show='showService' class="service"></Service>
		<Footer v-if='showHeaderAndFooter&&!hideFooter' :menus='bottomMenus' class="footer"></Footer>
		<div @click='scrollToTop' v-if='showBackTop' class="back-top">
			<Icon color='white' size='50' type="ios-arrow-up" />
		</div>
		
	</div>
</template>

<script>
	import loading from '@/components/order/loading'
	import Service from '@/components/common/Service'
	import mNavHeader from '@/components/header/mNavHeader'

	import {
	systemConfigMethods,
	cartInfoMethods,
	userInfoOrderMethods,
	promoCodeMethods
	} from "@/components/common/mixin";
	import {
		mapState,
		mapMutations,
		mapActions,
		mapGetters 
	} from 'vuex'
	export default {
		data() {
			return {
				topMenus:[],
				bottomMenus:[],
				showService:true,
				showBackTop:false,
			}
		},
		props: {
			active: {
				type: Number,
				default: 0,
			},
			loading:{
				type:Boolean,
				default:false,
			},
			customer:{
				type:Boolean,
				default:false,
			},
			canBackTop:{
				type:Boolean,
				default:true,
			},
			hideHeader:{
				type:Boolean,
				default:false,
			},
			hideFooter:{
				type:Boolean,
				default:false,
			}
		},
		created() {
			this.$nextTick(function() { 
				this.initData()
			})
		},
		mounted() {

		},
		watch:{
			$route(to){
				if (to.path.indexOf('community') != -1) {
					this.showService = false
				}
			}

		},
		mixins:[systemConfigMethods,userInfoOrderMethods, cartInfoMethods,promoCodeMethods],
		components: {
			Service,
			loading,
			mNavHeader,
		},
		computed: {
			...mapGetters(['getUserId']),
			...mapState({
				trace: state => state.common.trace,
				cartInfo: state => state.order.cartInfo,
				sysConfig: state => state.common.sysConfig,
				userInfo: state => state.common.wechatUserInfo,
				warehouseInfo: state => state.order.warehouseInfo,
				newpromoCode: state => state.order.newpromoCode
			}),
			warehouseList: function() {
				return [...((this.warehouseInfo || {}).value || {})];
			},
			showHeaderAndFooter(){
				let isAPP = navigator.userAgent.indexOf('com.doterra.app') != -1 || this.$route?.query?.from=='app'
				// let isWechat = navigator.userAgent.toLowerCase().indexOf('micromessenger') != -1
				return !isAPP //&& !isWechat
			}
		},
		methods: {
			...mapActions([
				'getMenuItemsAction','initCartAction','saveCartAction','getProductMenuTreeAction',
			]),
			...mapMutations([
				"SET_CART_TOTALRPT",
			]),
			async initData(){
				if (this.$route.path.indexOf('community') != -1) {
					this.showService = false
				}
				let response = await this.getMenuItemsAction()
				await this.getProductMenuTreeAction()
				let topMenus = [],bottomMenus = []
				response.Datas.forEach(item=>{
					if (item.MenuFlag == 10 || item.MenuFlag == 11) {
						topMenus.push(item)
					} else if(item.MenuFlag == 20 || item.MenuFlag == 21) {
						bottomMenus.push(item)
					}
				})
				this.topMenus = topMenus
				this.bottomMenus = bottomMenus
				if(!this.trace["cartInfo"]){
					await this.initCartAction(true);
					if(this.getUserId){
						this.setCartTotal(this.baseDeliveryFee, this.baseServiceFee, 0);
						let ll = this.shopCartList();
						let cv = this.cartInfo.value;
						let minCart = {
							id: cv.id,
							customer_id: this.userInfo.value.binding.user_id,
							store_id: this.default_store_id,
							address_id: 0,
							total_num: cv.num,
							total_price: cv.total_price,
							total_pv: cv.total_pv,
							total_change_point: cv.total_change_point,
							total_change_point_num: cv.total_change_point_num,
							total_product_amount: cv.total_product_amount,
							delivery_fee: cv.delivery_fee,
							service_fee: cv.service_fee,
							ar_value: cv.ar_value,
							pay_fee: cv.pay_fee,
							spec_code: null,
							detail: ll
						};
					 	await this.saveCartAction({ minCart, type: false });
					}	
				}
				else{
					this.initCartAction(false);
				}
			},
			shopCartList() {
				var  detail= (((this.cartInfo || {}).value || {}).detail || []);
				let newArr = new Array();
				this.shopCart.forEach(item => {
					if (item.num > 0) {
						var product_flag = item.is_lrpt_product || 0;
						if (item.is_hot == "1" && this.orderType != 0) {
							product_flag = 100;
						}
						var remark=null
						if(item.promo_code!=''&&item.promo_code){
							remark=this.getBySkuJson(item.sku)
						}
						newArr.push({
							attrs: [],
							extra: {},
							id: item.id,
							name: item.name,
							packing_fee: item.packing_fee,
							price: item.price,
							pt: item.pt,
							pv: item.pv,
							point: item.point,
							amount: item.amount, //现金支付金额
							ar_value: 0, //AR支付金额
							num: item.num, //数量(个数)，point支付和 amount支付总计个数
							sku_id: item.sku_id,
							sku: item.sku,
							specs: item.specs,
							stock: item.stock,
							selected: item.selected,
							spec_code: null,
							product_flag: product_flag,
							promo_code: item.promo_code,
							Url: null,
							remark:remark
						});
					}
				});
				return newArr;
			},
			setCartTotal(delivery_fee, service_fee, ar_value) {
				this.SET_CART_TOTALRPT({ delivery_fee, service_fee, ar_value });
			},
			scrollEvent(){
				let scrollTop = this.$refs.root&&this.$refs.root.scrollTop || 0
				this.showBackTop = scrollTop > 400 && this.canBackTop
				this.$emit('scrollEvent',scrollTop)
			},
			scrollToTop(){
				this.$refs.root.scrollTo({top: 0,behavior:'smooth'});
			},
			search(key){
				this.$emit('search',key);
			},
			colseCustomer(){
				this.$emit('colseCustomer');
			},
			
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/common';
	@import '@/style/mixin';
	.container {
		padding-top:1rem;
	}
	.service {
		position: fixed;
		bottom: 100px;
	}
	.mheader {
		display:none;
	}
	.loading {
		top:40%;
	}
	.back-top {
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		position:fixed;
		bottom:40px;
		right: 40px;
		width: 0.5rem;
		height: 0.5rem;
		min-width: 40px;
		min-height: 40px;
		background-color: $theme-color;
	}
	@media (max-width: 768px){
		.container {
			padding-top:2rem;
		}
		.header {
			display:none;
		}
		.mheader {
			display:flex;
		}
		.back-top {
			border-radius: 50px;
			width: 50px;
			height: 50px;
			min-width: 50px;
			min-height: 50px;
		}
	}
</style>
